import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import AttributeReduction from './AttributeReduction';
import Summary from './Summary';
import Inputs from './Inputs';
import Notes from './Notes';
import LegalOrgChart from './LegalOrgChart';
import BalanceSheet from './BalanceSheet';

function Main() {
    return (
        <Routes>
            <Route path="/" element={<AttributeReduction />}></Route>
            <Route path="/summary" element={<Summary />}></Route>
            <Route path="/inputs" element={<Inputs />}></Route>
            <Route path="/attribute-reduction" element={<AttributeReduction />}></Route>
            <Route path="/balance-sheet" element={<BalanceSheet />}></Route>
            <Route path="/legal-org-chart" element={<LegalOrgChart />}></Route>
            <Route path="/notes" element={<Notes />}></Route>
        </Routes>
    );
}

export default Main;